<template>
  <div v-if="items.length > 0">
    <div v-if="status === 'paid'" class="row">
      <div class="col text-right pa-4">
        <small>Total Pago</small> &nbsp; <b>{{ total | price }}</b>
      </div>
      <div class="col-auto text-right pa-4">
        <small>Juros pago</small> &nbsp; <b>{{ interest | price }}</b>
      </div>
    </div>
    <div v-if="status === 'pending'" class="row">
      <div class="col text-right pa-4">
        <small>Total em aberto</small> &nbsp; <b>{{ total | price }}</b>
      </div>
      <div class="col-auto text-right pa-4">
        <small>Multa/Juros</small> &nbsp; <b>{{ interest | price }}</b>
      </div>
    </div>
    <v-data-table
      dense
      :headers="headers"
      :items="items"
      loading-text="Carregando..."
      :loading="loading"
      :disable-pagination="true"
      no-data-text="Nenhuma fatura encontrada"
      no-results-text="Nenhum fatura encontrada"
      :hide-default-footer="true"
    >
      <template v-slot:item.total_amount="{ item }">
        {{ item.total_amount | price }}
      </template>
      <template v-slot:item.total_without_interest_and_fines="{ item }">
        {{ item.total_amount - item.total_interest_and_fines | price }}
      </template>
      <template v-slot:item.total_interest_and_fines="{ item }">
        {{ (item.total_interest_and_fines + generateFines(item.total_amount - item.total_interest_and_fines, item.due_date, item.celebration.daily_interest, item.celebration.fine_for_delay)) | price }}
      </template>
      <template v-slot:item.invoice_date="{ item }">
        {{ item.invoice_date | moment('MM/YYYY') }}
      </template>
      <template v-slot:item.due_date="{ item }">
        {{ item.due_date | moment('DD/MM/YYYY') }}
      </template>
      <template v-slot:item.payment_date="{ item }">
        {{ item.payment_date | moment('DD/MM/YYYY hh:mm') }}
      </template>
      <template v-slot:item.invoice_status="{ item }">
        <v-chip small class="my-1" :color="invoiceStatusColor(item.invoice_status)">
          {{ item.invoice_status | invoice_status }}
        </v-chip>
      </template>
    </v-data-table>
    <div class="pt-2">
      <small v-if="status === 'paid'">* Multa e juros referentes à faturas anteriores pagas em atraso</small>
      <small v-if="status === 'pending'">* Multa e juros referentes à faturas anteriores pagas em atraso + o juros acumulado até o dia da emissão desse documento.</small>
    </div>
  </div>
  <div class="py-2 text-center" v-else>
    O participante não tem faturas {{ status === 'paid' ? 'pagas' : 'em aberto' }}
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'invoices',
  props: ['customerId', 'celebrationId', 'status'],
  data () {
    return {
      loading: false,
      items: []
    }
  },
  computed: {
    ...mapGetters(['invoiceStatusColor']),
    headers () {
      const headers = [
        {
          text: 'Competência',
          value: 'invoice_date',
          sortable: false
        },
        {
          text: (this.status === 'paid') ? 'Pagamento' : 'Vencimento',
          value: (this.status === 'paid') ? 'payment_date' : 'due_date',
          sortable: false
        },
        {
          text: 'Valor',
          value: 'total_without_interest_and_fines',
          align: 'right',
          sortable: false
        },
        {
          text: 'Multa e juros *',
          value: 'total_interest_and_fines',
          align: 'right',
          sortable: false
        }
      ]
      if (this.status === 'paid') {
        headers.push({
          text: 'Total',
          value: 'total_amount',
          align: 'right',
          sortable: false
        })
      }
      if (this.status === 'pending') {
        headers.push({
          text: '',
          value: 'invoice_status',
          sortable: false
        })
      }
      return headers
    },
    // valueSelected () {
    //   let total = 0
    //   let interest = 0
    //   let interestOthers = 0
    //   for (let item in this.itemsSelected) {
    //     let totalAmount = this.itemsSelected[item].total_amount - this.itemsSelected[item].total_interest_and_fines
    //     let days = this.$moment().utcOffset(0).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).diff(this.$moment(this.itemsSelected[item].due_date + ' 00:00:00'), 'days')
    //     let dailyInterest = (days > 0) ? this.itemsSelected[item].celebration.daily_interest * totalAmount / 3000 * days : 0
    //     let fineForDelay = (days > 0) ? this.itemsSelected[item].celebration.fine_for_delay * totalAmount / 100 : 0
    //     console.log(totalAmount, days, this.itemsSelected[item].celebration.daily_interest, dailyInterest, this.itemsSelected[item].celebration.fine_for_delay, fineForDelay)
    //     total = (parseFloat(total) + totalAmount).toFixed(2)
    //     interestOthers = (parseFloat(interestOthers) + parseFloat(this.itemsSelected[item].total_interest_and_fines)).toFixed(2)
    //     interest = (parseFloat(interest) + dailyInterest + fineForDelay).toFixed(2)
    //   }
    //   return { total, interest, interestOthers }
    // },
    params () {
      let params = '?page[size]=30'
      if (this.customerId) params += '&filter[customer_id]=' + this.customerId
      if (this.celebrationId) params += '&filter[celebration_id]=' + this.celebrationId
      if (this.status === 'paid') params += '&filter[invoice_status]=paid'
      if (this.status === 'pending') params += '&filter[invoice_status]=late,pending'
      params += '&sort=invoice_date'
      return params
    },
    total () {
      let total = 0
      for (const index in this.items) total += this.items[index].total_amount - this.items[index].total_interest_and_fines
      return total
    },
    interest () {
      let interest = 0
      for (const index in this.items) {
        const item = this.items[index]
        interest += item.total_interest_and_fines
        if (this.status === 'pending') interest += this.generateFines(item.total_amount - item.total_interest_and_fines, item.due_date, item.celebration.daily_interest, item.celebration.fine_for_delay)
      }
      return interest
    },
    daysAfterDueDate () {
      if (this.celebrationId === 'cefa8bd2-e96f-46a3-9c18-036346a91080') return 1
      return 4
    }
  },
  methods: {
    getData (page) {
      let vue = this
      vue.loading = true

      if (!page) {
        page = 1
        vue.items = []
      }

      axios.get('invoices' + vue.params + '&page[number]=' + page)
        .then(response => {
          vue.items = [...vue.items, ...response.data.data.filter(e => !!e.invoice_url)]
          if (response.data.meta.last_page > page) this.getData(page + 1)
        })
        .catch(() => {
          vue.items = []
          vue.pagination.total = 0
        })
        .finally(() => {
          vue.loading = false
        })
    },
    generateFines (value, date, dailyInterestTax, fineForFelayTax) {
      if (this.status === 'paid') return 0
      let days = this.$moment().utcOffset(0).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).diff(this.$moment(date + ' 00:00:00'), 'days')
      let dailyInterest = (days > this.daysAfterDueDate) ? dailyInterestTax * value / 3000 * days : 0
      let fineForDelay = (days > this.daysAfterDueDate) ? fineForFelayTax * value / 100 : 0
      return dailyInterest + fineForDelay
    }
  },
  created () {
    this.getData()
  }
}
</script>
